﻿import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import IconLoader from './IconLoader';

interface Props {
  message: string;
}

const NoData: React.FC<Props> = ({ message }) => {
  return (
    <Grid
      container
      spacing={1}
     sx={{ alignItems: 'center', justifyContent: 'center',  flexDirection: 'column' }}>
      <Grid
        size={{ xs: 12, sm: 12, md: 6, xl: 6 }}
        sx={{ display: 'flex', justifyContent: 'center' }}
      >
        <IconLoader name="NoPatients" />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 6, xl: 6 }}>
        <Typography sx={{ mb: 2, textAlign: 'center' }}>{message}</Typography>
      </Grid>
    </Grid>
  );
};

export default NoData;
